/**
 * @generated SignedSource<<d55093b84324fa83ea3abfc557e87881>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSellerDetailsBio_seller$data = {
  readonly isRewardsTier2: boolean | null;
  readonly liveStorefrontProfile: {
    readonly aboutUsUnbranded: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerDetailsBioModal_seller">;
  readonly " $fragmentType": "PdpSharedSellerDetailsBio_seller";
};
export type PdpSharedSellerDetailsBio_seller$key = {
  readonly " $data"?: PdpSharedSellerDetailsBio_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerDetailsBio_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSellerDetailsBio_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": "isRewardsTier2",
      "args": [
        {
          "kind": "Literal",
          "name": "listName",
          "value": "SELLER_REWARDS_2"
        }
      ],
      "kind": "ScalarField",
      "name": "isAnchorListMember",
      "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StorefrontProfile",
      "kind": "LinkedField",
      "name": "liveStorefrontProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "aboutUsUnbranded",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerDetailsBioModal_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "1da081618c953cfad9179f4d67ceabd5";

export default node;
